import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
export function PainPoints() {
  const points = [{
    problem: 'Buscás ejercicios de programación para tus alumnos',
    consequence: 'Todo está en inglés, es universitario o no tiene nada que ver con la secundaria técnica'
  }, {
    problem: 'Querés enseñar lógica de programación desde cero',
    consequence: 'No encontrás material progresivo que conecte la teoría con el laboratorio real'
  }, {
    problem: 'Armás tus actividades desde cero',
    consequence: 'Cada semana. Cada año. Sin que nadie lo vea ni lo valore'
  }, {
    problem: 'Tus evaluaciones son improvisadas',
    consequence: 'Sin criterios claros ni rúbricas para trabajos prácticos de código'
  }, {
    problem: 'La teoría no conecta con el laboratorio',
    consequence: 'Los alumnos no entienden para qué sirve lo que aprenden'
  }, {
    problem: 'Domingo, 11 de la noche',
    consequence: 'El cursor parpadea en un Word en blanco y mañana hay clase de programación'
  }];
  return <section className="py-6 md:py-12 px-3 bg-brand-dark" data-id="element-161">
      <div className="max-w-3xl mx-auto" data-id="element-162">
        <h2 className="text-xl md:text-3xl font-black text-center mb-4 text-white leading-tight" data-id="element-163">
          💣 ¿CUÁNTOS DOMINGOS MÁS VAS A PERDER ASÍ?
        </h2>

        <p className="text-xs md:text-base text-gray-300 mb-5 text-center max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-164">
          Sos docente de programación o maestro de taller en una escuela técnica
          industrial. Sabés lo que es pararte frente a 25 pibes que van a
          programar sistemas reales cuando egresen.
          <br data-id="element-165" />
          <br data-id="element-166" />
          <span className="text-brand-accent font-bold" data-id="element-167">
            Pero nadie te dio un sistema pensado para la realidad del
            laboratorio técnico argentino.
          </span>
        </p>

        <div className="space-y-2 mb-6" data-id="element-168">
          {points.map((point, index) => <div key={index} className="bg-brand-card border-l-4 border-red-500 p-3 md:p-4 rounded-r-lg flex flex-col md:flex-row md:items-center gap-1 md:gap-4" data-id="element-169">
              <div className="flex items-start md:w-1/2" data-id="element-170">
                <AlertTriangle className="w-4 h-4 text-red-500 mr-2 shrink-0 mt-0.5" data-id="element-171" />
                <p className="text-sm md:text-base text-white font-bold" data-id="element-172">
                  {point.problem}
                </p>
              </div>
              <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-173"></div>
              <div className="md:w-1/2 pl-6 md:pl-0" data-id="element-174">
                <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-175">
                  {point.consequence}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center mb-4" data-id="element-176">
          <p className="text-base md:text-xl font-black text-brand-accent neon-glow" data-id="element-177">
            👉 No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <div className="text-center" data-id="element-178">
          <h3 className="text-lg md:text-3xl font-black text-white" data-id="element-179">
            💡 ¿Y SI ESTE FUERA EL ÚLTIMO DOMINGO ASÍ?
          </h3>
        </div>
      </div>
    </section>;
}